export default __webpack_public_path__ + "static/media/y_wdt_c_2.166f50e6.mp3";